import type { Profile } from '../services/auth';

import { getAvailableLanguages } from './availableLanguages';
import i18n from './config';
import type { SupportedLanguages } from './constants';
import { DEFAULT_LANGUAGE } from './constants';

export const getUserLanguage = (
  userLanguage: Profile['language'] = i18n.language,
  availableLanguages: SupportedLanguages[] = getAvailableLanguages(),
): SupportedLanguages => {
  if (!userLanguage) {
    return DEFAULT_LANGUAGE;
  }
  const language = userLanguage.toUpperCase() as SupportedLanguages;

  if (availableLanguages.includes(language)) {
    return language;
  }

  return DEFAULT_LANGUAGE;
};
